import React from 'react';
import { CallbackQueue } from './src/components/CallbackQueue';
export function App() {
  return <CallbackQueue data-id="element-0" />;
}